import { sizeMapper } from "src/styles";
import styled, { css } from "styled-components";

interface FormLabelProps {
  margin?: string;
  noTransform?: boolean;
  noWrapLabel?: boolean;
  size?: "normal" | "small" | "medium";
}

const FormLabel = styled.label<FormLabelProps>`
  grid-column: 1/-1;
  display: inline-block;
  pointer-events: none;
  text-transform: capitalize;
  color: ${(props) => props.theme.grayDark};
  transform: ${(p) => (p.noTransform ? "initial" : "translateY(23px)")};
  position: relative;
  z-index: 1;
  margin: ${(props) => sizeMapper(props.margin, "no")};

  ${(props) =>
    props.noWrapLabel &&
    css`
      white-space: nowrap;
    `}
`;

export default FormLabel;
